import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Typography, Result } from 'antd';
import { ArrowLeftOutlined, LockOutlined } from '@ant-design/icons';
import './Unauthorized.css';

const { Title, Text } = Typography;

export function Unauthorized() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-2);
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <Button 
          type="link" 
          icon={<ArrowLeftOutlined />} 
          onClick={handleGoBack}
          className="back-button"
        >
          Go back
        </Button>
        
        <Result
          icon={<LockOutlined className="unauthorized-icon" />}
          title={<Title level={2}>Access Denied</Title>}
          subTitle={
            <Text type="secondary">
              You do not have the necessary permissions to access this page.
            </Text>
          }
          extra={
            <Button 
              type="primary" 
              onClick={handleGoBack}
              className="unauthorized-button"
            >
              Go back
            </Button>
          }
        />
      </div>
    </div>
  );
} 